export const TILE_TYPES = {
  ALL: 'all',
  FEEDBACK: 'feedback',
  SURVEY: 'survey',
  QUIZ: 'quiz',
  QA: 'qa',
};
